import React from 'react';
import Gallery from './Gallery';
import Logo from './img/logo.png';
import './Gallery'

function App() {
  return (
    <>
    <h3 className='logo'><img src={Logo} alt="logo angelin"/>Photo Angelin</h3>
    <h1 style={{textAlign: 'center'}}>Pictures Gallery</h1>
    <h4 style={{textAlign: 'center'}}>All the images that I upload are taken by myself.</h4>
    <h4 style={{textAlign: 'center'}}>To build this mini project gallery I use React JS.</h4>
    <Gallery />
    </>
  );
}

export default App;
